import { useMemo, useCallback } from 'react';
import { Button, Card, Flex, Space, Tag, Typography, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { CalendarOutlined, DeleteOutlined, EditOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import { NoteProps } from '../interfaces';

const { Text } = Typography;

export const Note = ({ note, onEdit, onDelete, userName, categoryOptions }: NoteProps) => {
  const { t } = useTranslation();
  const { text, category, date, user } = note;
  const isOwner = user === userName;

  const categoryLabel = useMemo(() => {
    return categoryOptions?.find(x => x.value === category)?.label ?? category;
  }, [category, categoryOptions]);

  const onEditNote = useCallback(() => {
    onEdit(note);
  }, [note, onEdit]);

  const onDeleteNote = useCallback(() => {
    onDelete(note);
  }, [note, onDelete]);

  return (
    <Card size="small">
      <Space orientation="vertical" style={{ width: '100%' }}>
        <Flex justify="space-between">
          <Tag variant="outlined">{categoryLabel}</Tag>
          <Tooltip key="share" title={t('lender.firms.buttons.editNote')} placement="top">
            <Button
              type="text"
              aria-label="Edit note"
              size="small"
              variant="text"
              icon={<EditOutlined />}
              onClick={onEditNote}
              disabled={!isOwner}
              style={{ color: isOwner ? 'var(--enso-icon-brand)' : undefined }}
            />
          </Tooltip>
        </Flex>
        <Text>{text}</Text>
        <Flex justify="space-between">
          <Space size="large">
            <Space>
              <CalendarOutlined />
              <Text>{dayjs(date).format('YYYY-MM-DD')}</Text>
            </Space>
            <Space>
              <UserOutlined />
              <Text>{user}</Text>
            </Space>
          </Space>
          <Tooltip key="share" title={t('lender.firms.buttons.deleteNote')} placement="top">
            <Button
              type="text"
              aria-label="Delete note"
              size="small"
              variant="text"
              icon={<DeleteOutlined />}
              danger
              onClick={onDeleteNote}
              disabled={!isOwner}
            />
          </Tooltip>
        </Flex>
      </Space>
    </Card>
  );
};
